export default "__VITE_ASSET__BEBmIFhN__"